import { Controller } from '@hotwired/stimulus'
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {

  visitSelectedLink(event){
    let element = event.currentTarget
    let url = element.options[element.selectedIndex].value
    Turbo.visit(url)
  }
}
